import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import PartnerView from './PartnerView';
import SelectedContact from '../../contact/SelectedContact';
import withPermission from '../../../utils/withPermission';
import ActivityList from '../lead/activity/ActivityList';
import PartnerPricing from '../partner/PartnerPricing'; // Added import for PartnerPricing

const PartnerDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "partnerInfo";
    const [partnerDetails, setPartnerDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('initialTab');
    const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);



    const didFetchRef = useRef(false);

    const fetchPartnerDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/partners/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            console.log(response.data); // Check the data structure

            setPartnerDetails(response.data.data); // Set the fetched data to state
        } catch (error) {
            console.error('Error fetching instance details:', error);
        }
    };


    useEffect(() => {
        if (!didFetchRef.current) {
            fetchPartnerDetails(); // Only fetch data if it hasn't been done before
            didFetchRef.current = true; // Mark that data has been fetched
        }
    }, [id]); // This will run only when `id` changes

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const activeTabParam = queryParams.get("activeTab") || "partnerInfo";
        setActiveTab(activeTabParam);
    }, [location.search]);
    const handleBackClick = () => {
        navigate(-1);
    };

    // Handle tab click to change active tab
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        navigate(`${location.pathname}?activeTab=${tab}`);

    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Partner Details</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><Link to={`/partner/details/${id}?activeTab=partnerInfo`}>
                                            {partnerDetails?.name || " Partner Details"}
                                        </Link></li>
                                        <li className="breadcrumb-item active">Details</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="email-leftbar card">
                                <div className="card-body">

                                    <a
                                        onClick={() => handleTabClick('partnerInfo')}
                                        className={`list-group-item list-group-item-action ${activeTab === 'partnerInfo' ? 'active-tab' : ''}`}
                                    >
                                        Partner Details
                                    </a>

                                    <a
                                        onClick={() => handleTabClick('activityInfo')}
                                        className={`list-group-item list-group-item-action ${activeTab === 'activityInfo' ? 'active-tab' : ''}`}
                                    >
                                        Activity
                                    </a>
                                    <a
                                        onClick={() => handleTabClick('productInfo')}
                                        className={`list-group-item list-group-item-action ${activeTab === 'productInfo' ? 'active-tab' : ''}`}
                                    >
                                        Product
                                    </a>

                                    <WithContactPermission><a
                                        onClick={() => handleTabClick('partner-contacts')}
                                        className={`list-group-item list-group-item-action ${activeTab === 'partner-contacts' ? 'active-tab' : ''}`}
                                    >
                                        Contacts
                                    </a></WithContactPermission>

                                    <a
                                        onClick={() => handleTabClick('partnerPricing')}
                                        className={`list-group-item list-group-item-action ${activeTab === 'partnerPricing' ? 'active-tab' : ''}`}
                                    >
                                        Partner Pricing
                                    </a>

                                    <div className="button-container">
                                        <button onClick={handleBackClick} className="btn btn-secondary mb-4 back">Back</button>
                                    </div>
                                </div>
                            </div>
                            {/* Right Content */}
                            {/* <div className="col-sm-11"> */}
                            <div className="email-rightbar">
                                <div>
                                    <div>
                                        {activeTab === 'partnerInfo' && partnerDetails && (
                                            <PartnerView data={partnerDetails} partnerId={partnerDetails.id} setPartnerDetails={setPartnerDetails} contacts={partnerDetails?.contacts || []} />
                                        )}

                                        {activeTab === 'partner-contacts' && partnerDetails && (
                                            <SelectedContact
                                                partnerId={partnerDetails?.id}
                                                entityType="partner"
                                                fetchPartnerData={fetchPartnerDetails}
                                                partnerData={partnerDetails}
                                                setPartnerDetails={setPartnerDetails}
                                            />
                                        )}

                                        {activeTab === 'activityInfo' && partnerDetails && (
                                            <ActivityList
                                                partnerId={partnerDetails?.id}
                                                type='partner'
                                            />
                                        )}

                                        {activeTab === 'partnerPricing' && partnerDetails && (
                                            <PartnerPricing
                                                partnerId={partnerDetails?.id}
                                            />
                                        )}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartnerDetails;
